import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section ref={ref} className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-card/30" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] rounded-full bg-primary/3 blur-[120px]" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-2 mb-6">
            <Sparkles className="w-5 h-5 text-primary" />
            <span className="text-sm text-primary tracking-wide">Ready to create?</span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-title mb-6 leading-tight">
            Let&apos;s Craft Something
            <br />
            <span className="text-gradient-cyan">Extraordinary</span>
          </h2>

          <p className="text-base text-body mb-10 max-w-md mx-auto">
            From corporate events to personal masterpieces, every creation tells a unique story.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/inquiry">
              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 gap-2 tracking-wide shadow-cyan px-8">
                Start Your Project
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
            <Link to="/events">
              <Button size="lg" variant="outline" className="gap-2 tracking-wide border-border text-title hover:bg-secondary px-8">
                View Events
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
